import { Button, Grid, Typography } from '@material-ui/core';
import { DataGrid, ColDef, ValueFormatterParams } from '@material-ui/data-grid';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CreditCardIcon from '@material-ui/icons/CreditCard';

import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';

import { ctx, IStore } from 'store';
import Modal from 'components/Modal';

import { useStyles } from './styles';

const Billing: React.FC = () => {
  const classes = useStyles();
  const actions = useContext(ctx.actions);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [month, setMonth] = useState<string>('');
  const [amountToBePaid, setAmountToBePaid] = useState<number>(0);

  useEffect(() => {
    const fetch = async () => {
      const data = currentTeam.teamId
        ? { team: currentTeam.teamId, platform: 'slack' }
        : { team: currentTeam.tenantId, platform: 'microsoft' };
      await ((actions.misc.setLoading(true) as unknown) as Promise<IStore>);
      await ((actions.teams.getSummaries(data.team, data.platform) as unknown) as Promise<IStore>);
      await ((actions.misc.setLoading(false) as unknown) as Promise<IStore>);
    };

    if (!summaries.length) {
      fetch();
    }
  }, []);

  const {
    teams: { currentTeam, summaries },
  } = useContext(ctx.store);

  const columns: ColDef[] = [
    {
      flex: 1,
      field: 'month',
      headerName: 'Month',
      sortable: true,
      valueGetter: (params: any) => moment(params.value).format('MMMM YY'),
    },
    {
      flex: 0.6,
      field: 'activeMembers',
      headerName: 'Active Members',
      sortable: false,
    },
    {
      flex: 0.6,
      field: 'amount',
      headerName: 'Amount',
      sortable: false,
      valueGetter: (params: any) => `${params.value.toFixed(2)} USD`,
    },
    {
      flex: 0.6,
      field: 'status',
      headerName: 'Account Type',
      sortable: false,
    },
    {
      flex: 0.6,
      field: 'realAmount',
      headerName: 'To Be Paid',
      sortable: false,
      valueGetter: (params: any) => `${params.value.toFixed(2)} USD`,
    },
    {
      flex: 0.4,
      field: 'paid',
      headerName: 'Status',
      renderCell: (params: ValueFormatterParams) => {
        if (params.data.paid) {
          return (
            <Button variant="contained" color="secondary" startIcon={<CheckCircleOutlineIcon />}>
              Paid
            </Button>
          );
        } else {
          return (
            <Button
              variant="contained"
              color="primary"
              startIcon={<CreditCardIcon />}
              onClick={() => setModal(params.getValue('realAmount'), params.getValue('month'))}
            >
              Pay
            </Button>
          );
        }
      },
    },
  ];

  const setModal = (amount: any, month: any) => {
    setOpenModal(true);
    setMonth(month);
    setAmountToBePaid(amount);
  };

  return (
    <Grid container item xs={12} className={classes.root}>
      <Typography component="h1" variant="h5">
        Billing
      </Typography>
      <DataGrid
        className={classes.listStyle}
        rows={summaries}
        columns={columns}
        hideFooterSelectedRowCount={false}
      />
      <Modal
        modalStatus={openModal}
        closeModal={() => setOpenModal(false)}
        amount={amountToBePaid}
        month={month}
      />
    </Grid>
  );
};

export { Billing };
